import styles from './IconButton.module.css'

interface IconButtonProps {
  children: React.ReactNode
  onClick?: () => void
  title?: string
  showDot?: boolean
}

export default function IconButton({ children, onClick, title, showDot }: IconButtonProps) {
  return (
    <button type="button" className={styles.btn} onClick={onClick} title={title} aria-label={title}>
      {children}
      {showDot && <span className={styles.dot} />}
    </button>
  )
}
